import { IValidation } from '../validation.interfaces';
export class RegexValidation implements IValidation {

    public validate(regex: any, x: any): boolean | Promise<boolean> {
        const result = regex.exec(x);
        return result ? result[0] === x : false;
    }

    public canValidate(): boolean | Promise<boolean> {
        return true;
    }
}